import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { useSiteConfig } from "../lib/site";

export default function NotFound() {
  const config = useSiteConfig();

  return (
    <>
      <Seo
        title="Page not found | Dorothy Read Healing"
        description="The page you were looking for is not here. Visit the homepage or contact Dorothy Read Healing directly."
        path="/404"
      />
      <section className="mx-auto max-w-3xl px-6 py-24 text-center" data-testid="not-found-page">
        <p className="eyebrow">Page not found</p>
        <h1 className="mt-4 font-serif text-5xl font-semibold tracking-tight text-primary">
          This page has moved on
        </h1>
        <p className="mx-auto mt-6 max-w-xl text-lg text-foreground/90">
          The page you were looking for is no longer here. Everything current - services, rates and how
          to book - is on the pages below.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/" data-testid="notfound-home-link" className="btn-primary">Back to the homepage</Link>
          <Link to="/contact" data-testid="notfound-contact-link" className="btn-secondary">
            Contact Dorothy
          </Link>
        </div>
      </section>
    </>
  );
}
